import React from 'react';

import NavActions from 'lib/NavActions';
import CTAButton from 'components/CTAButton';
import HomePageBannerImage from '../../../assets/images/Banner-Desktop-2.webp';
import HomePageBannerMobileImage from '../../../assets/images/microsite-hero-mobile.webp';

import HomePageBannerStyles from './_HomePageBannerStyles.module.scss';

const HomePageBanner = (): JSX.Element => {
    const {
        navToTermsAndConditions,
    } = NavActions;
    return (
        <section className={HomePageBannerStyles.container}>
            <picture>
                <source
                    media='(max-width: 768px)'
                    srcSet={HomePageBannerImage}
                // This should be mobile but we dont have mobile
                />

                <img
                    src={HomePageBannerImage}
                    alt='CooperVision Rewards Program'
                    className={HomePageBannerStyles['banner-image']}
                />
            </picture>
            <CTAButton
                label='Terms and Conditions'
                onClick={navToTermsAndConditions}
                className={HomePageBannerStyles.button}
            />
        </section>
    );
};

export default HomePageBanner;
